import React, { useState, useEffect } from 'react';

import { Player } from '../player/Player';

import { hash } from 'shared/utils/hash/hash';
import { BlobPlayerProps } from './BlobPlayer.types';

export const BlobPlayer = ({ src, title, subtitle }: BlobPlayerProps) => {
  const [blob, setBlob] = useState<string>('');

  useEffect(() => {
    setBlob(URL.createObjectURL(src));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hash(src)]);

  return <Player playlist={[{ src: blob, title, subtitle }]} />;
};
